import { render, staticRenderFns } from "./TaskTypesList.vue?vue&type=template&id=63fbfbf5"
import script from "./TaskTypesList.vue?vue&type=script&lang=js"
export * from "./TaskTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports